import Label from "../Label/Label";

const PrivacyPolicyContent = ({
  policy,
  showBanner = false,
  bannerImage = null,
}) => {
  if (!policy) {
    return null;
  }

  return (
    <>
      {showBanner && bannerImage && (
        <div className="policy_Img">
          <img
            src={bannerImage}
            className="w-100 position-relative"
            alt={policy.bannerName || policy.title || "Policy banner"}
          />
          <div className="img_Txt">
            <Label title={policy.bannerName || policy.title || "Policy"} />
          </div>
        </div>
      )}

      <div className="main_section">
        <div className="top_content">
          <div className="top_heading">
            <Label title={policy.title || "Privacy Policy"} className="heading" />
            <div className="inner_text">
              {(policy.data || []).map((item) => (
                <Label
                  key={item.id || item.textDesc}
                  title={item.textDesc}
                  className="text1"
                />
              ))}
            </div>
          </div>
        </div>

        {(policy.subTitle ||
          policy.subDesc ||
          policy.list?.length ||
          policy.descriptionList?.length) && (
          <div className="middle_content">
            <div className="middle_heading">
              {policy.subTitle && (
                <Label className="heading" title={policy.subTitle} />
              )}
              {policy.subDesc && (
                <Label className="text" title={policy.subDesc} />
              )}

              {policy.list?.length > 0 && (
                <div className="list">
                  <ul>
                    {policy.list.map((item) => (
                      <li key={item.id || item.textDesc}>{item.textDesc}</li>
                    ))}
                  </ul>
                </div>
              )}

              {policy.descriptionList?.length > 0 && (
                <div className="inner_text">
                  {policy.descriptionList.map((item) => (
                    <Label
                      key={item.id || item.textDesc}
                      title={item.textDesc}
                      className="text1"
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PrivacyPolicyContent;
